import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '@angular/http';

@Injectable()
export class ErrorService {

  constructor() { }

  handleError(error: Response | any) {
        // remote logging infrastructure
        let errMsg: string;
        let err: any;
        let errMessage: string;
        errMessage = '';

        // console.log(error);
        // if (error instanceof Response) {
        //     err = error.text();
        //     const errArray = JSON.parse(err);
        //     errArray.Errors.forEach(element => {
        //         errMessage += element.Message + '<br>';
        //     });
        //     errMsg = error.status ? `${errMessage}` : 'Server No Response';
        // } else {
        //     errMsg = error.message ? error.message : error.toString();
        // }
        return Observable.throw(error);
  }
}
